import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import { Router } from 'react-router';
import { PublicClientApplication, InteractionType, } from "@azure/msal-browser";
import { loginRequest, msalConfig ,initilizeMsal} from "./azure/authConfig";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";

/**
 * Sandeep: Azure B2C configuration.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
initilizeMsal(msalInstance);
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

ReactDOM.render(
    <MsalProvider instance={msalInstance}>
        <Router history={history}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest} >
                <App />
            </MsalAuthenticationTemplate>
        </Router>
    </MsalProvider>,

    document.getElementById('root'));